// extracted by mini-css-extract-plugin
export var actionButton = "_87-1";
export var actionButtons = "_87-2";
export var actions = "_87-0";
export var aiUnread = "_87-10";
export var alignCenter = "_87-h";
export var backWrapper = "_87-3";
export var cellContainer = "_87-4";
export var checkboxContainer = "_87-5";
export var contentContainer = "_87-6";
export var contentHeader = "_87-8";
export var conversationsTableWrapper = "_87-s";
export var draftReplyBadgeContainer = "_87-m";
export var dropdownItem = "_87-b";
export var dropdownItemsContainer = "_87-a";
export var dropdownTitle = "_87-c";
export var errorIcon = "_87-7";
export var filter = "_87-d";
export var gray = "_87-i";
export var headerActionButtons = "_87-e";
export var headerCheckboxContainer = "_87-f";
export var icon = "_87-j";
export var menuContainer = "_87-k";
export var noMoreTicketsIcon = "_87-12";
export var noMoreTicketsSubText = "_87-13";
export var oneLine = "_87-l";
export var optionsButton = "_87-n";
export var plus = "_87-o";
export var portalButtonsWrapper = "_87-g";
export var red = "_87-p";
export var scrolledTop = "_87-9";
export var search = "_87-q";
export var selectedConversationsCount = "_87-r";
export var spinner = "_87-t";
export var strong = "_87-u";
export var summaryCell = "_87-v";
export var tableContainer = "_87-11";
export var tagContainer = "_87-w";
export var threeDots = "_87-x";
export var twoLines = "_87-y";
export var unread = "_87-z";